import { getWidgetDataFromTwig } from './getWidgetDataFromTwig';

const getWidgetsShopUrl = (companyId: string | null) => {
    if (companyId) {
        return `/company/${companyId}?activeTab=widgets-shop-tab`;
    }

    const widgetsListRoute =
        // @ts-ignore
        typeof routable !== 'undefined' ? routable.getRoute('getWidgetsList') : '';
    // const matchedCompanyId = getIdFromUrlPath('company');
    const matchedCompanyId = widgetsListRoute.match(/\/company\/([^/]+)\/widget\/list/)?.[1];
    console.log('matchedCompanyId', matchedCompanyId);
    return matchedCompanyId ? `/company/${matchedCompanyId}?activeTab=widgets-shop-tab` : null;
};

export const handleWidgetActionFromTwig = ({
    elementIdentifier,
    onWidgetAvailable,
    onOpenDetails,
}: {
    elementIdentifier: string;
    onWidgetAvailable: () => void;
    onOpenDetails: (widgetId: string) => void;
    onOpenOnlyAdmin?: (widgetId: string | null) => void;
}) => {
    const {
        widgetId,
        companyId,
        isWidgetAvailable,
        hasWidgetDetails,
        availableActionType,
    } =
        getWidgetDataFromTwig(elementIdentifier);

    if (isWidgetAvailable) {
        onWidgetAvailable();
        return;
    }

    if (!hasWidgetDetails) {
        if (availableActionType === 'upgrade_tariff' && widgetId) {
            onOpenDetails(widgetId);
            return;
        }

        const widgetsShopUrl = getWidgetsShopUrl(companyId);

        if (widgetsShopUrl && typeof window !== 'undefined') {
            window.location.assign(widgetsShopUrl);
        }
        return;
    }

    if (widgetId) {
        onOpenDetails(widgetId);
    }
};
